import React from "react";
import Badge from "./Badge";
import { colors, layout, spacing } from "./theme";

export default function Topbar({
  title = "Ecovanta Workspace",
  subtitle = "AI Sustainability Intelligence Platform",
  user = {
    name: "Jules",
    role: "super_admin",
    plan: "enterprise"
  }
}) {
  const initials = String(user?.name || "U")
    .trim()
    .charAt(0)
    .toUpperCase();

  return (
    <header style={topbarStyle}>
      <div>
        <h1 style={titleStyle}>{title}</h1>
        <p style={subtitleStyle}>{subtitle}</p>
      </div>

      <div style={rightAreaStyle}>
        <div style={searchBoxStyle}>
          <span style={{ color: colors.textSoft }}>⌕</span>
          <input
            placeholder="Search workspace..."
            style={searchInputStyle}
          />
        </div>

        {user?.plan && (
          <Badge tone="primary" size="sm">
            {String(user.plan).toUpperCase()}
          </Badge>
        )}

        <button style={iconButtonStyle} title="Notifications">
          🔔
        </button>

        <div style={userPillStyle}>
          <span style={avatarStyle}>{initials}</span>

          <div>
            <div style={userNameStyle}>{user?.name || "User"}</div>
            <div style={userRoleStyle}>{user?.role || "member"}</div>
          </div>
        </div>
      </div>
    </header>
  );
}

const topbarStyle = {
  height: layout.topbarHeight,
  background: colors.surface,
  borderBottom: `1px solid ${colors.border}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `0 ${spacing["2xl"]}px`,
  position: "sticky",
  top: 0,
  zIndex: 800
};

const titleStyle = {
  margin: 0,
  fontSize: 18,
  fontWeight: 800,
  color: colors.text
};

const subtitleStyle = {
  margin: 0,
  marginTop: 2,
  fontSize: 12,
  color: colors.textMuted
};

const rightAreaStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.md
};

const searchBoxStyle = {
  minWidth: 260,
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  padding: "8px 12px",
  border: `1px solid ${colors.border}`,
  borderRadius: 999,
  background: colors.surfaceMuted
};

const searchInputStyle = {
  border: "none",
  outline: "none",
  background: "transparent",
  width: "100%",
  fontSize: 13,
  color: colors.text
};

const iconButtonStyle = {
  border: `1px solid ${colors.border}`,
  background: colors.surface,
  borderRadius: 999,
  width: 38,
  height: 38,
  cursor: "pointer"
};

const userPillStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  padding: "6px 10px",
  border: `1px solid ${colors.border}`,
  borderRadius: 999,
  color: colors.text,
  background: colors.surface
};

const avatarStyle = {
  width: 30,
  height: 30,
  borderRadius: 999,
  background: colors.primaryLight,
  color: colors.primaryDark,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 800
};

const userNameStyle = {
  fontSize: 13,
  fontWeight: 800,
  lineHeight: 1.2
};

const userRoleStyle = {
  fontSize: 11,
  color: colors.textMuted,
  lineHeight: 1.2
};